module.exports = __webpack_public_path__ + "../assets/img/c7f5ac4217eefd3f6015efcd61eb6a86.svg";